import { useCallback, useId } from 'react';

import { useRegisterModal } from '@/contexts/layout/use-register-modal';

const CPOPOVER_REGISTRATION_ID = 'cpopover';

interface UsePopoverModalRegistrationInput {
  onClose?: () => void;
  visible: boolean;
}

export function usePopoverModalRegistration({
  onClose,
  visible,
}: UsePopoverModalRegistrationInput): void {
  const modalRegistrationId = useId();
  const handleClose = useCallback((): void => {
    onClose?.();
  }, [onClose]);

  // Cpopover owns its anchored backdrop and z-index. Registering with no shared
  // backdrop keeps Escape/back-stack behavior without adding another overlay.
  useRegisterModal({
    id: `${CPOPOVER_REGISTRATION_ID}-${modalRegistrationId}`,
    visible: visible && Boolean(onClose),
    onClose: handleClose,
    backdrop: null,
  });
}
